const RequestFormDataDto = {
	id: null,
	formDataCode: null,
	formDateName: null,
	objectSchema: "",
	objectModel: "",
	option: "",
	createdName: "",
	createdDate: new Date(),
	modifiedName: "",
	modifiedDate: new Date(),
	isActive: true,
	isDelete: false,
	requestData: null,
	form: null,
	created: null,
	modified: null,
};
export default RequestFormDataDto;
